import styled, { createGlobalStyle } from 'styled-components'
import { normalize } from 'styled-normalize'
import { theme } from 'styled-tools'

export const GlobalStyle = createGlobalStyle<any>`
    ${normalize}

    /* SSR'dan gelen device bilgisini CSS custom property olarak sakla */
    :root {
        --is-mobile-device: ${(props) => (props.isMobile ? '1' : '0')};
    }

    #__next {
        display: flex;
        flex-direction: column;
        min-height: 100vh;
    }
    html {
        box-sizing: border-box;
        overflow-x: hidden;
    }

    body {
        overflow-x: hidden;
        line-height: 1.5;
        color: var(--text-colors-text, #131717);
        background-color: ${(props) => (props.isMobile ? '#F8FAF9' : '#FFFFFF')};
    }

    /* Reading text: slightly taller line-height for Arabic/RTL (1.6–1.8) */
    html[dir='rtl'] body {
        line-height: 1.7;
    }

    html[dir='rtl'] :where(p, li, td, th, dd, dt, figcaption, blockquote, article, section) {
        line-height: 1.7;
    }

    *,
    *::before,
    *::after {
        box-sizing: border-box;
        text-decoration: none;
    }

    a {
        color:inherit;
        cursor:pointer;
    }

    .disabled {
        pointer-events: none;
        opacity: 0.4;
    }

    * {
        font-family: ${(props) => props.font};
    }



    .splide__arrow {
        transition: opacity 100ms ease-out;
        background: #ffffff;
        border-radius: 200px;
        width: 44px;
        height: 44px;
        border: 0px;
    }

    .splide__spinner {
        display: none;
        visibility: hidden;
    }

    .splide__spinner::after {
        display: none;
        visibility: hidden;
    }

      .splide__spinner::before {
        display: none;
        visibility: hidden;
    }

    /* DisplaySettings: dil listesi satırı — test id'li satırın doğrudan ilk div çocuğunda padding yok */
    [data-testid^='language-select-option-'] > div:first-child {
        padding: 0 !important;
    }
`

export const ShadowStyled = styled.div`
  z-index: 1;
  box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.04), 0 2px 1px -1px rgba(0, 0, 0, 0.08);
  background-color: ${theme('colors.sky.extraLight')};
`

export const AbsoluteImage = styled.div<{ responsive: boolean }>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  img {
    width: ${(props) => (props.responsive ? '100%' : undefined)};
    height: ${(props) => (props.responsive ? 'auto' : undefined)};
  }
`

export const IconWrapper = styled.div`
  background: ${(props) => props.bgColor};
  width: 100%;
  height: 100%;
  border: none;
  padding-left: 3px;
  cursor: pointer;

  [dir='rtl'] && {
    padding: 0px 3px 0px 0px;
  }
`

export const TooltipText = styled.p`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #131717;
  margin: 0;
`
